<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vz2IfU/tc-custom/9781488040771.jpg?1731166484077" alt="This image is the cover for the book Her Forgotten Amish Past"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Her Forgotten Amish Past
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman on the run with amnesia seeks shelter with an Amish man and his family, in this inspirational romantic suspense from a <i>USA Today</i>–bestselling author.</b><br/><br/>Someone wants Becca Troyer dead, but who or why is a mystery to her. Seeking refuge at the home of Amish farmer Zeke Hochstetler is her only hope to stay one step ahead of the killer. With every clue she finds about her past leading to more confusion, Becca and Zeke must untangle the truth before her pursuer discovers where she’s been hiding.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Debby Giusti
      </h2>
      
      <p class="authorDescription body article">&#160;Debby Giusti is a medical technologist who loves working with test tubes and petri dishes almost as much as she loves to write. Growing up as an Army Brat, Debby met and married her husband--then a Captain in the Army--at Fort Knox, Kentucky. Together they traveled the world, raised three wonderful Army Brats of their own and have now settled in Atlanta, Georgia, where Debby spins tales of suspense that touch the heart and soul.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0589c5b6